var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"post-navigator flex"},[_c('button',{staticClass:"active",on:{"click":function($event){return _vm.getAllPosts($event.target)}}},[_vm._v("Teraz")]),_vm._l((_vm.years),function(year,index){return _c('button',{key:index,on:{"click":function($event){return _vm.getPostsByYear(index, $event.target)}}},[_vm._v(_vm._s(year))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }